import axios, { AxiosInstance } from "axios";
import {
  KustomApiContent,
  KustomApiContentResponse,
  KustomApiContentsResponse,
  KustomApiTemplateRevision,
  KustomApiTemplateRevisionResponse,
} from "../../types/api";
import { Content } from "../../types/customization/content";
import { convertToContentFormat } from "../../utils/customization/format/content";
import { getVariableByEnv } from "../../utils/variableByEnv";

const DEFINITION_VERSION_RANGE = "5-6";

const KUSTOM_BACKEND_URL = getVariableByEnv("REACT_APP_KUSTOM_BACKEND_URL");

export default class KustomApiProvider {
  api: AxiosInstance;

  constructor(token?: string) {
    const headers = {
      Accept: "application/json",
      Authorization: token ? `Token token="${token}"` : null,
    };

    this.api = axios.create({
      baseURL: `${KUSTOM_BACKEND_URL}/api/v1/`,
      headers,
    });
  }

  async getContents(): Promise<KustomApiContent[]> {
    const { data } = await this.api.get<KustomApiContentsResponse>("/contents", {
      params: {
        definition_version_range: DEFINITION_VERSION_RANGE,
      },
    });

    return data.contents;
  }

  async getContent(contentId: string): Promise<KustomApiContent> {
    const { data } = await this.api.get<KustomApiContentResponse>(`/contents/${contentId}`, {
      params: {
        definition_version_range: DEFINITION_VERSION_RANGE,
      },
    });

    return data.content;
  }

  async getTemplateRevision(templateRevisionId: string): Promise<KustomApiTemplateRevision> {
    const { data } = await this.api.get<KustomApiTemplateRevisionResponse>(
      `/template_revisions/${templateRevisionId}`,
      {
        params: {
          definition_version_range: DEFINITION_VERSION_RANGE,
        },
      }
    );

    return data.template_revision;
  }

  async saveContent(contentId: string, content: Content): Promise<KustomApiContent> {
    const requestData = {
      content: {
        definition: convertToContentFormat(content),
      },
    };

    const { data } = await this.api.put<KustomApiContentResponse>(
      `/contents/${contentId}`,
      requestData
    );

    return data.content;
  }

  async createContent(templateRevisionId: string, content: Content): Promise<KustomApiContent> {
    const requestData = {
      content: {
        definition: convertToContentFormat(content),
        definition_version: 6,
        template_revision_id: templateRevisionId,
      },
    };

    const { data } = await this.api.post<KustomApiContentResponse>("/contents", requestData);

    return data.content;
  }
}
